export default "__VITE_ASSET__f8dd436c__"